/**
 * Extract basic product information from button element (fallback)
 *
 * @since 1.0.0
 */

import type { RedFoxCartProduct } from '@/frontend/types/cart';

/**
 * Extract basic product information from button element (fallback)
 *
 * @param button - Button element
 */
export const extractProductFromButton = (button: HTMLElement): RedFoxCartProduct | null => {
  try {
    // Get quantity from various data attributes
    const quantity = button.getAttribute('data-quantity') ?? button.getAttribute('data-qty') ?? '1';

    // Extract product name from data attributes or surrounding DOM
    let productName = button.getAttribute('data-product-name') ?? button.getAttribute('title');
    if (!productName) {
      const productForm = button.closest('.product, .cart, form');
      if (productForm) {
        const nameElement = productForm.querySelector('.product_title, .product-title, h1, h2, h3');
        productName = nameElement?.textContent?.trim() ?? null;
      }
    }

    if (!productName) {
      productName = button.textContent?.trim() ?? 'Unknown Product';
    }

    return {
      name: productName,
      regular_price: 0,
      sale_price: 0,
      formatted_price: '$0.00',
      quantity: parseInt(quantity, 10) || 1,
      image_url: '',
      image_alt: productName,
      is_on_sale: false,
      is_variation: false,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error extracting product from button:', error);
    return null;
  }
};
